import { useMemo } from 'react'
import { ModalContent } from './types'
import { RequestDocumentHistory } from '@/services/healthClaim/useRequestDocumentList/types'
import { useRequestDocumentList } from '@/services/healthClaim/useRequestDocumentList'
import { useParams } from 'react-router-dom'

export const CancelDocumentRequestModalHook = () => {
  const { claimFormId } = useParams<{ claimFormId?: string }>()
  const { data: requestDocumentList } = useRequestDocumentList(claimFormId || '')
  const modalContent: ModalContent = {
    title: 'ต้องการยกเลิกการขอเอกสารเพิ่มเติมหรือไม่',
    content: 'คุณมีรายการขอเอกสารเพิ่มเติม ดังนี้',
    confirmText: 'ยืนยัน',
    cancelText: 'กลับไปตรวจสอบ',
  }

  const DocumentRequest = useMemo(() => {
    const apiRecords = requestDocumentList ?? []

    if (apiRecords.length === 0) {
      return null
    }

    const sortedRecords = [...apiRecords].sort((a, b) => {
      const dateA = new Date(a.requestDate).getTime()
      const dateB = new Date(b.requestDate).getTime()
      return dateB - dateA
    })

    const latestDocumentRequest: RequestDocumentHistory = sortedRecords?.[0] || null

    return latestDocumentRequest
  }, [requestDocumentList])

  return {
    modalContent,
    DocumentRequest,
  }
}
